import { FC, useState } from 'react'
import { RedRed60, SequenceMenu } from '@sequencehq/core-components'
import { DeleteCreditNoteDialog } from 'CreditNotes/components/dialog/DeleteCreditNoteDialog'

type Props = {
  creditNoteId: string
  onClose: () => void
  onDeleted?: () => void
}

export const DeleteCreditNoteMenuItem: FC<Props> = ({
  creditNoteId,
  onClose,
  onDeleted
}) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <SequenceMenu.Item
        uuid="delete-credit-note"
        data-testid={`creditNotes.${creditNoteId}.menuItem.delete`}
        label="Delete credit note"
        style={{ color: RedRed60 }}
        onClick={e => {
          e.stopPropagation()
          setShowModal(true)
        }}
      />
      {showModal && (
        <DeleteCreditNoteDialog
          creditNoteId={creditNoteId}
          isOpen
          onClose={() => {
            setShowModal(false)
            onClose()
          }}
          onSuccess={onDeleted}
        />
      )}
    </>
  )
}
